import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

export default function Navbar(props) {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-secondary">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">{props.title}</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target=" navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link active" aria-current="page" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="./About.js">{props.abouttext}</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="./Contact.js">{props.contactText}</Link>
                        </li>

                    </ul>
                    <form action='https://www.google.com/searh/' className="d-flex" role="search" autoComplete='off'>
                        <input className="form-control me-2" type="search" name='q' placeholder="Search" aria-label="Search" />
                        <button type='submit' className="btn btn-primary">Submit</button>
                    </form>
                </div>
            </div>
        </nav>
    )
}

Navbar.propTypes = {
    title: PropTypes.string,
    abouttext: PropTypes.string
}

Navbar.defaultProps = {
    title: 'AR Infotech',
    abouttext: 'Links'
}